export default __webpack_public_path__ + "static/media/image09.30f2bd43.jpg";